export default __webpack_public_path__ + "static/media/img-callcenter.04ec4136.svg";